/**
 * <s-drone-finder> — Sends the visitor to accessories or parts for the drone they pick.
 *
 * Required markup:
 *   <form>                         — Native GET to the search route, the no-JS fallback.
 *   select[name="q"]               — Options carry data-accessories-url and data-parts-url (from Liquid routes).
 *   input[name="finder-type"]      — Radios with value "accessories" or "parts".
 *   [data-finder-error]            — Polite live region; data-message and data-no-parts-message hold its copy.
 */
class DroneFinder extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const form = this.querySelector('form');
    if (!form) return;

    form.addEventListener(
      'submit',
      (event) => {
        const select = form.querySelector('select[name="q"]');
        const option = select?.selectedOptions[0];
        const error = this.querySelector('[data-finder-error]');

        if (!option || !option.value) {
          event.preventDefault();
          if (error) error.textContent = error.dataset.message || '';
          select?.focus();
          return;
        }

        const type = form.querySelector('input[name="finder-type"]:checked')?.value || 'accessories';
        const url = type === 'parts' ? option.dataset.partsUrl : option.dataset.accessoriesUrl;
        // Liquid leaves data-parts-url empty for models with no tagged parts, so say so instead of opening an empty list.
        if (!url && type === 'parts') {
          event.preventDefault();
          if (error) error.textContent = error.dataset.noPartsMessage || '';
          return;
        }
        if (!url) return;

        event.preventDefault();
        if (error) error.textContent = '';
        window.location.assign(url);
      },
      { signal: this.#controller.signal },
    );

    form.addEventListener(
      'change',
      () => {
        const error = this.querySelector('[data-finder-error]');
        if (error) error.textContent = '';
      },
      { signal: this.#controller.signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-drone-finder')) {
  customElements.define('s-drone-finder', DroneFinder);
}
